import { Trans } from '@lingui/macro'
import {
  FormLabel,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  TextField,
  Tooltip
} from '@mui/material'
import { authRoles, isOnlyRole } from 'app/auth/authRoles'
import { setOrganization } from 'app/redux/actions/OrganizationActions'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import { getAccountParsedById } from 'app/services/sfAuth/sfData/sfAccount'
import { saveUser } from 'app/services/sfAuth/sfData/sfUser'
import { sortBy } from 'lodash'
import { useSnackbar } from 'notistack'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import ProgressSnackbar from '../common-components/CustomSnackbars'
import { GRANTS_PATH } from '../grants/GrantsRoutes'

/** This component is used in the header of the app to select the current organization. */
export const SelectOrganizationDropdown = ({ isSmallScreen = false }) => {
  const avaliable = useSelector((state) => state.avaliableOrganizations)
  const currentOrg = useSelector((state) => state.organization)
  const user = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const [updating, setUpdating] = React.useState(null)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const simulateInternal = useSelector(
    (state) => state?.testingOptions?.simulateInternal
  )
  const isInternal = simulateInternal || sfOauthConfig.isInternal

  const blurOnSelection = () => {
    setTimeout(() => {
      document.getElementById('organizationDropdown').blur()
    }, 200)
  }

  if (
    isOnlyRole(user.role, authRoles.DMAH) ||
    isOnlyRole(user.role, authRoles.selectionCommittee)
  ) {
    return null
  }

  if (isInternal) {
    return (
      <>
        <div style={{ padding: 10 }}>
          {!isSmallScreen && (
            <FormLabel style={{ fontWeight: 'bold' }}>
              <Trans>Current organization</Trans>
            </FormLabel>
          )}
          <div>{currentOrg.organisationsName}</div>
        </div>
        <Grid item>
          <Tooltip title={<Trans>CONNECT_WITH_ORGANIZATION</Trans>}>
            <NavLink to='/grants/Organizations' className='nav-item'>
              <IconButton size='large'>
                <Icon>autorenew</Icon>
              </IconButton>
            </NavLink>
          </Tooltip>
        </Grid>
      </>
    )
  }

  return (
    <div className='select-organization-box'>
      {!isSmallScreen && (
        <div className='organization-prompt'>
          <Trans>Current organization</Trans>
        </div>
      )}
      <TextField
        id='organizationDropdown'
        select
        disabled={Boolean(updating) || avaliable.length === 0}
        // label={<Trans>Current organization</Trans>}
        sx={{ width: { xl: 300, lg: 300, md: 300, s: 250, xs: 250 } }}
        variant='outlined'
        value={updating || currentOrg.id || ''}
        SelectProps={{
          SelectDisplayProps: {
            compact: true,
            id: 'organizationDropdown'
          },
        }}
        onChange={(e) => {
          const orgId = e.target.value
          blurOnSelection()
          if (orgId === 'join') return
          setUpdating(orgId)
          const saving = enqueueSnackbar('', {
            variant: 'info',
            persist: true,
            content: (key) =>
              ProgressSnackbar(<Trans>Selecting organization</Trans>)
          })
          Promise.all([
            getAccountParsedById(orgId, {
              permissions: { TEAM_MEMBERS: true }
            }),
            saveUser({
              Id: user.userId,
              Associated_Organizations__c: orgId
            })
          ]).then(
            ([org, saveUser]) => {
              const newCurrent = { ...org }
              closeSnackbar(saving)
              enqueueSnackbar(<Trans>Organization selected!</Trans>, {
                variant: 'success'
              })
              dispatch(setOrganization(newCurrent))
              setUpdating(null)
            },
            (reject) => {
              closeSnackbar(saving)
              enqueueSnackbar(
                <Trans>Error occured while selecting this organization!</Trans>,
                {
                  variant: 'error'
                }
              )
              setUpdating(null)
            }
          )
        }}
      >
        {sortBy(avaliable, 'name')
          .filter((org) => !org.name.toLowerCase().includes('duplicate'))
          .map((org, index) => (
            <MenuItem value={org.id} key={index}>
              {org.name}
            </MenuItem>
          ))}
        <MenuItem value='join' style={{ fontWeight: 'bold' }}>
          <Link to={GRANTS_PATH.JOIN_ORGANIZATION}>
            <Trans>ADD_OR_JOIN_ORGANIZATION</Trans>
          </Link>
        </MenuItem>
      </TextField>
    </div>
  )
}
